const obatLainnya = (state = [], action) => {
  switch (action.type) {
    case 'GET_OBAT_LAINNYA': {
      const payload = Array.isArray(action.payload) ? action.payload : action.payload?.data ?? [];

      return [...state, ...payload];
    }

    case 'RESET_OBAT_LAINNYA':
      return [];

    default:
      return state;
  }
};

const obatLainnyaTotalPage = (state = 0, action) => {
  switch (action.type) {
    case 'GET_TOTAL_PAGE_OBAT_LAINNYA':
      return action.payload;
      break;
    default:
      return state;
      break;
  }
};

export { obatLainnya, obatLainnyaTotalPage };
